import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { HttpClientModule } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UiModule } from '@coin/importer/core/feature';
import { AuthUserState } from '@coin/shared/auth/data-access';
import { AuthComponentsModule, AuthGmsAngularClientModule, UserState } from '@coin/shared/auth/feature';
import { AuthGmsClientConfig } from '@coin/shared/auth/util';
import { ApiModule as ApiModuleV2, Configuration as ConfigurationV2 } from '@coin/shared/core/data-access-v2';
import {
  AppEnvironment,
  CustomTranslationLoader,
  provideTranslateDebugStore
} from '@coin/shared/core/data-access-translation-loader';
import { environment } from '@coin/shared/core/util-environments';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ToastrModule } from 'ngx-toastr';
import { SimplebarAngularModule } from 'simplebar-angular';
import { ROUTES } from './app.routes';
import { httpInterceptorProviders } from './auth/http-interceptors';
import { DemoMaterialModule } from './material.module';
import { LogsService } from './services/logs/logs.service';
import { EmailListService } from './services/organisation-management/email-list.service';
import { StructureListService } from './services/organisation-management/structure-list.service';
import { TransferListService } from './services/organisation-management/transfer-list.service';
import { TOAST_OPTIONS, ToastService } from './services/toast/toast.service';
import { UploadService } from './services/upload/upload.service';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      RouterModule.forRoot(ROUTES),
      HttpClientModule,
      ApiModuleV2.forRoot(() => new ConfigurationV2({ basePath: environment.api.baseUrl })),
      FormsModule,
      MatSliderModule,
      DemoMaterialModule,
      UiModule,
      SimplebarAngularModule,
      ToastrModule.forRoot(TOAST_OPTIONS),
      AuthComponentsModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWithDelay:5000'
      }),
      AuthGmsAngularClientModule.forRoot({
        ...environment.authentication,
        ...environment.importerAuthentication
      } as AuthGmsClientConfig),
      TranslateModule.forRoot(CustomTranslationLoader.createConfig(AppEnvironment.Admin))
    ),
    { provide: AuthUserState, useExisting: UserState },
    httpInterceptorProviders,
    LogsService,
    ToastService,
    UploadService,
    provideCharts(withDefaultRegisterables()),
    TransferListService,
    StructureListService,
    EmailListService,
    TranslateModule,
    TranslateService,
    provideTranslateDebugStore(),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } } // fix for https://jira.siemens-energy.com/browse/GMTEC-22822
  ]
};
